<template>
    <AppModal :name="name"
              :beforeClose="beforeClose"
              :beforeOpen="beforeOpen"
              :onEnterKeyPress="save"
              width="500">

        <template slot="header">
            Add field
        </template>

        <template slot="content">
            <div class="form-group text-left mb-3">
                <label for="field-section" class="workflow-label">
                    Section
                </label>
                <multiselect
                    :value="sections.find(s => s.key === field.section.key)"
                    @select="onSectionSelect"
                    :options="sections"
                    track-by="key"
                    label="label"
                    id="field-section"
                    class="multiselect-md"
                    :maxHeight="120"/>
                <small v-if="$v.field.section.key.$error" class="form-text text-danger">
                    <span v-if="!$v.field.section.key.required">This field is required</span>
                </small>
            </div>
            <div v-if="sections.length === 0" class="text-left">
                <div class="text-muted">
                    No available sections
                </div>
                <span @click="addSection" class="text-purple clickable text-semi-bold">
                    + Add
                </span>
            </div>
            <template v-else>
                <div class="form-group text-left">
                    <!-- TODO: treeselect -->
                    <label for="field-path" class="workflow-label">
                        Map to
                        <span class="text-muted"
                              v-tooltip="{content: 'Map to property <br/> (unique path to a data property)'}">
                            <i class="fal fa-info-circle"></i>
                        </span>
                    </label>
                    <input v-model.trim="field.path"
                           @input="vuelidateDelayTouch($v.field.path, touchMap)"
                           type="text"
                           id="field-path"
                           class="form-control"
                           placeholder="Field map to">
                    <small v-if="$v.field.path.$error" class="form-text text-danger">
                        <span v-if="!$v.field.path.required">This field is required</span>
                    </small>
                </div>
                <div class="form-group text-left">
                    <label for="field-label" class="workflow-label">
                        Label
                        <span class="text-muted" v-tooltip="'How it will be displayed in the interface'">
                            <i class="fal fa-info-circle"></i>
                        </span>
                    </label>
                    <input v-model.trim="field.label"
                           @input="vuelidateDelayTouch($v.field.label, touchMap)"
                           type="text"
                           id="field-label"
                           class="form-control"
                           placeholder="Field label">
                    <small v-if="$v.field.label.$error" class="form-text text-danger">
                        <span v-if="!$v.field.label.required">This field is required</span>
                    </small>
                </div>
            </template>
        </template>

        <template slot="actions">
            <div class="text-right">
                <button @click="$modal.hide(name)" class="btn btn-link d-inline-block">
                    Close
                </button>
                <button v-loading.btn="isLoading" @click="save" class="btn btn-primary d-inline-block">
                    Add
                </button>
            </div>
        </template>

    </AppModal>
</template>

<script>
import {required} from 'vuelidate/lib/validators'
import {FieldEditorTypes} from '../../../../../types/document-viewer/field/modules/editor'
import {FormSystemSections} from '../../../../../types/document-viewer/section'

export default {
    name: 'AddFormField',
    props: {
        name: {
            type: String,
            required: true
        },
        sections: {
            type: Array,
            required: true
        },
        fields: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            touchMap: new WeakMap(),

            field: {
                path: '',
                label: '',
                section: {
                    key: null,
                    order: null,
                    cols: 4
                }
            },
            isLoading: false
        }
    },
    validations: {
        field: {
            section: {
                key: {required}
            },
            path: {required},
            label: {required}
        }
    },
    methods: {
        beforeClose() {
            Object.assign(this.$data, this.$options.data.apply(this))
            this.$v.$reset()
        },

        beforeOpen({params}) {
        },

        onSectionSelect(section) {
            this.$set(this.field.section, 'key', section.key)
            const sectionFields = this.fields.filter(f => f.section.key === section.key)
            if (sectionFields.length !== 0) {
                const lastField = _.maxBy(this.fields.filter(f => f.section.key === section.key), 'section.order')
                const order = lastField && lastField.section && _.isNumber(lastField.section.order)
                    ? lastField.section.order : 0
                this.$set(this.field.section, 'order', order)
            } else {
                this.$set(this.field.section, 'order', 0)
            }
        },

        save() {
            if (this.$v.$invalid) {
                this.$v.$touch()
                return
            }

            // TODO: add treeselect
            let path = this.field.path
            let renderer = {}
            if (this.field.section.key === FormSystemSections.LINES) {
                path = `lines.${path}`
                renderer = {width: 90}
            } else if (this.field.section.key === FormSystemSections.LANDED_COST_LINES) {
                path = `lcLines.${path}`
            } else if (this.field.section.key === FormSystemSections.CONTACT) {
                path = `company.${path}`
            } else if (this.field.section.key === FormSystemSections.ALLOCATIONS) {
                path = `allocations.${path}`
            }

            const field = {
                path,
                label: this.field.label,
                section: this.field.section,
                tooltip: '',
                custom: true,
                visible: true,
                editable: true,
                editor: {
                    type: FieldEditorTypes.TEXT
                },
                renderer,
                validations: [],
                rules: [],
                actions: [],
                dependants: []
            }
            this.$emit('add', field)
            this.$modal.hide(this.name)
        },

        addSection() {
            this.$modal.show('add-form-section')
            this.$modal.hide('add-form-field')
        }
    }
}
</script>

<style scoped>

</style>
